export const NAV = [
  { label: "Home", to: "/" },
  {
    label: "About",
    to: "/about",
    children: [
      { label: "About the Ministry", to: "/about" },
      { label: "Our Evangelism", to: "/evangelism" },
      { label: "Departments & Ministries", to: "/departments" },
      { label: "Leadership", to: "/leadership" },
    ],
  },
  { label: "The Church", to: "/tabernacle-of-grace" },
  {
    label: "Media",
    to: "/sermons",
    children: [
      { label: "Sermons", to: "/sermons" },
      { label: "Podcasts", to: "/podcasts" },
      { label: "Videos", to: "/videos" },
      { label: "Gallery", to: "/gallery" },
    ],
  },
  {
    label: "Connect",
    to: "/events",
    children: [
      { label: "Events", to: "/events" },
      { label: "Announcements", to: "/announcements" },
      { label: "Prayer Requests", to: "/prayer-requests" },
      { label: "Contact", to: "/contact" },
    ],
  },
  { label: "Give", to: "/giving" },
];
